import * as React from 'react';
import { Icon, Tooltip, Select } from 'antd';
import injectSheet from 'react-jss';
import usePagination, { usePaginationReturnType } from 'src/actions/usePagination';

const styles = theme => ({
  disabledStyle : {
    pointerEvents: 'none !important',
    cursor: 'default !important',
    color: theme.colors.textTertiary,
  },
  rfqDisabledStyle : {
    pointerEvents: 'none !important',
    cursor: 'default !important',
    color: theme.colors.border,
  },
  rfqEnabledStyle : {
    color: theme.colors.textSecondary,
  },
});

class SimplePaginator extends React.PureComponent<any, any> {
  state: any = {
    activeToolTip: 0,
  };

  render() {
    const { pageNumber, isNext, classes, loading, styles, isRfqCustomStyle, isShipmentHandler } = this.props;
    return (
      <div style={{ display: 'flex', justifyContent: 'center',
        padding: '6px', ...styles }} >
        <Tooltip title={pageNumber !== 1 && !loading && this.state.activeToolTip === 1
          ? 'Go to First Page' : null}
          mouseLeaveDelay={0}>
            <a onMouseEnter={() => { this.setState({ activeToolTip: 1 }); } }
              onMouseLeave={() => { this.setState({ activeToolTip: 0 }); } }
            className= {pageNumber && pageNumber !== 1 && !loading 
              ? `${isRfqCustomStyle ? classes.rfqEnabledStyle : {}}` 
              : `${isRfqCustomStyle ? classes.rfqDisabledStyle : classes.disabledStyle}`}>
              <Icon type="vertical-right"
                style={{ marginRight: isShipmentHandler ? 4 : '12px' }}
                onClick={pageNumber && pageNumber !== 1 && !loading ?
                  this.props.onFirstClick : null}
              ></Icon>
            </a>
          </Tooltip>
        <Tooltip title={pageNumber !== 1 && !loading && this.state.activeToolTip === 2
          ? 'Go to Previous Page' : null}
          mouseLeaveDelay={0}>
            <a onMouseEnter={() => { this.setState({ activeToolTip: 2 }); } }
              onMouseLeave={() => { this.setState({ activeToolTip: 0 }); } }
            className= {pageNumber && pageNumber !== 1 && !loading
              ? `${isRfqCustomStyle ? classes.rfqEnabledStyle : {}}` 
              : `${isRfqCustomStyle ? classes.rfqDisabledStyle : classes.disabledStyle}`}>
              <Icon
                type="left"
              onClick={pageNumber && pageNumber !== 1 && !loading ?
                  this.props.onPrevClick : null } />
            </a>
          </Tooltip>
        <div style={{ marginLeft: isShipmentHandler ? 4 : '12px', marginRight: isShipmentHandler ? 4 : '12px', fontSize: 14 }} >
          {this.props.pageNumber}
        </div>
        <Tooltip title={isNext && !loading && this.state.activeToolTip === 3
          ? 'Go to Next Page' : null}
          mouseLeaveDelay={0}>
          <a onMouseEnter={() => { this.setState({ activeToolTip: 3 }); } }
              onMouseLeave={() => { this.setState({ activeToolTip: 0 }); } }
          className= {isNext && !loading 
            ? `${isRfqCustomStyle ? classes.rfqEnabledStyle : {}}` 
            : `${isRfqCustomStyle ? classes.rfqDisabledStyle : classes.disabledStyle}`}>
            <Icon
              type="right"
              onClick={isNext && !loading ? this.props.onNextClick : null} />
          </a>
        </Tooltip>
      </div>
    );
  }
}

export const Paginator = ({
  pagination,
  showSizeChanger = false,
  pageSizeOptions = [10, 25, 50, 100],
  style = {},
  className,
}: {
  pagination: usePaginationReturnType,
  showSizeChanger?: boolean,
  pageSizeOptions?: number[],
  style?: React.CSSProperties,
  className?: string;
}) => {
  const {
    state: paginationState,
    actions,
  } = pagination;

  const handleFirstPageClick = () => {
    actions.setPagination({
      currentPageNumber: 1,
      nextOrPrev: 'first',
    });
  };

  const handlePrevClick = () => {
    actions.setPagination({
      currentPageNumber: paginationState.pagination.currentPageNumber,
      nextOrPrev: 'prev',
    });
  };

  const handleNextClick = () => {
    actions.setPagination({
      currentPageNumber: paginationState.pagination.currentPageNumber,
      nextOrPrev: 'next',
    });
  };

  return <div className={className} style={{
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flex: 1,
    ...style,
  }}>
    <SimplePaginatorStyled
      onFirstClick={handleFirstPageClick}
      isNext={paginationState.pagination.isNextPresent}
      onPrevClick={handlePrevClick}
      onNextClick={handleNextClick}
      loading={paginationState.isLoading}
      pageNumber={paginationState.pagination.currentPageNumber}
    />
    {showSizeChanger && <PageSize pagination={pagination} pageSizeOptions={pageSizeOptions}/>}
  </div>;
};

export const PageSize = ({
  pagination,
  pageSizeOptions = [10, 25, 50, 100],
} : {
  pagination: usePaginationReturnType,
  pageSizeOptions?: number[],
}) => {

  const {
    state: paginationState,
    actions,
  } = pagination;

  return <Select value={`${paginationState.pagination.resultPerPage} / page`}
    disabled={paginationState.isLoading}
    onChange={(resultPerPage: string) => {
      const next = Number(resultPerPage);
      if (next !== paginationState.pagination.resultPerPage) {
        actions.setPagination({ resultPerPage: next });
      }
    }}
    style={{
      marginLeft: 12,
    }}>
      {pageSizeOptions.map(size => <Select.Option key={size} value={size}> {size} / page</Select.Option>)}
  </Select>;
};

const SimplePaginatorStyled = injectSheet(styles)(SimplePaginator);
export default SimplePaginatorStyled;
